<div
    class="image-upload"
    (dragover)="onDragOver($event)"
    (drop)="onDrop($event)"
>
    <input
        #fileInput
        type="file"
        class="visually-hidden"
        [accept]="acceptAttr"
        (change)="onFileSelected($event)"
    />

    @if (uploading()) {
        <div class="tile uploading">
            <span class="prompt">
                <span class="prompt-text">Uploading image…</span>
            </span>
            <span class="edit-badge decorative" aria-hidden="true">
                <span class="icon-edit"></span>
            </span>
        </div>
    } @else if (previewUrl()) {
        <div class="tile has-image" [class.backdrop]="showBackdrop()">
            <img
                class="preview-image"
                [src]="previewUrl()"
                [alt]="label() + ' preview'"
            />
            <button
                type="button"
                class="edit-badge"
                [attr.aria-label]="'Replace ' + label()"
                (click)="openPicker()"
            >
                <span class="icon-edit"></span>
            </button>
        </div>
    } @else {
        <div class="tile empty">
            <button
                type="button"
                class="fill"
                [attr.aria-label]="'Upload ' + label()"
                (click)="openPicker()"
            >
                <span class="prompt">
                    <span class="prompt-text">{{ promptText() }}</span>
                    <span
                        class="icon-image prompt-icon"
                        aria-hidden="true"
                    ></span>
                </span>
            </button>
            <!-- Overhanging affordance; duplicates the fill button's action, so hidden from AT. -->
            <button
                type="button"
                class="edit-badge"
                tabindex="-1"
                aria-hidden="true"
                (click)="openPicker()"
            >
                <span class="icon-edit"></span>
            </button>
        </div>
    }

    @if (errorMessage()) {
        <p class="error" role="alert">{{ errorMessage() }}</p>
    }
</div>
